import { useStaticQuery, graphql } from "gatsby"
export const useFooter = () => {
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query {
        allMarkdownRemark(
          filter: { frontmatter: { key: { eq: "footer" } } }
        ) {
          edges {
            node {
              frontmatter {
                content
              }
            }
          }
        }
      }
    `
  )
  return allMarkdownRemark.edges
}